import { OrderServicePlan } from "./order_service_plan.model";

interface IOrder {
    orderId: string;
    userId: string;
    status: string;
    note: string;
    createDateUTC: Date;
    updateDateUTC: Date;
    orderServicePlanModel: OrderServicePlan[];
    processingFee: number;
    costOfServices: number;
    total: number;

}

export class Order {
    orderId: string;
    userId: string;
    status: string;
    note: string;
    createDateUTC: Date;
    updateDateUTC: Date;
    orderServicePlanModel: OrderServicePlan[];
    processingFee: number;
    costOfServices: number;
    total: number;

    constructor();
    constructor(object: IOrder);
    constructor(object?: any) {
        this.orderId = object && object.orderId || null;
        this.userId = object && object.userId || null;
        this.status = object && object.status || null;
        this.note = object && object.note || null;
        this.createDateUTC = object && object.createDateUTC || null;
        this.updateDateUTC = object && object.updateDateUTC || null;
        this.orderServicePlanModel = object && object.orderServicePlanModel || null;
        this.processingFee = object && object.processingFee || null;
        this.costOfServices = object && object.costOfServices || null;
        this.total = object && object.total || null;

    }
}